import ReactDOM from 'react-dom';
import 'src/mocks';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import ScrollTop from 'src/hooks/useScrollTop';
import adapter from 'webrtc-adapter';
import 'webrtc-adapter';

import 'nprogress/nprogress.css';
import { Provider } from 'react-redux';
import store from 'src/store';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
// import { StompHeaders, StompSessionProvider } from 'react-stomp-hooks';
import { getAuthorizationHeader } from './utils/http';
import CallProvider from './slices/call';
import { SOCKET_URL } from './utils/constant';
import { EchoProvider } from 'src/contexts/EchoContext';
import { PusherProvider } from './contexts/PusherContext';
const headers = {
  Authorization: getAuthorizationHeader()
};
ReactDOM.render(

  <HelmetProvider>
    <Provider store={store}>
    
      <CallProvider>
        <SidebarProvider>
          <BrowserRouter>
            <ScrollTop />
              <App />
          </BrowserRouter>
        </SidebarProvider>
      </CallProvider>

    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
